import { useAuthContext } from "@/contexts/AuthContext";

export type UserRole = "admin" | "supplier" | "buyer" | "support";

/**
 * useAuth hook - now uses AuthContext to prevent duplicate auth listeners
 * This ensures a single source of truth for authentication state
 */
export function useAuth() {
  const context = useAuthContext();
  
  // Map context values to match expected interface
  return {
    user: context.user,
    roles: context.roles,
    hasRole: context.hasRole,
    loading: context.loading,
    rolesError: context.rolesError,
    sessionChecked: !context.loading, // Session is checked when not loading
  };
}
